import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDefaultClient,
  unSnapDefaultClient,
} from "store/user/(default)/client/default_client.action";

//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(snapDefaultClient());
    return () => dispatch(unSnapDefaultClient());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
